import { REDUCE_BOUND_POLICIES } from '../../constants/actions/policies';

export function reduceBoundPolicies(payload) {
    return {
        type: REDUCE_BOUND_POLICIES,
        payload,
    };
}
